var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",staticClass:"overflow-x-hidden overscroll-contain scroll-touch relative",class:[
    _vm.appearance,
    _vm.colors,
    _vm.hideTrack ? 'scrollbar-track-transparent' : '',
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }